import { IconUpload } from '@tabler/icons-react';
import React, { useState, useEffect } from 'react';


const ActionButtonUploadFile = ({ row, handleIdVariable, handleShowUpload }) => {

    return (
        <>
            &nbsp;&nbsp;<button
                className="btn btn-sm btn-outline-info"
                type="button"
                onClick={() => {
                    handleIdVariable(row);
                    handleShowUpload();
                }}
                title='Upload Dokumen'
            >
                <IconUpload stroke={2} />
            </button>
        </>
    );
};

export default ActionButtonUploadFile;